import { createSearchParams, useNavigate } from 'react-router';
import { useCallback } from 'react';

import { createRequiredContext } from 'src/context/createRequiredContext';
import {
  AgreementFormEnum,
  EscrowPartyTypeEnum,
  type IDepositor,
  type IBeneficiary,
  type Maybe,
} from 'src/graphql/schema';

const [useParty, PartyProvider] = createRequiredContext<{
  type: EscrowPartyTypeEnum;
  agreementForm: AgreementFormEnum;
  showSignatories: boolean;
  onEdit: () => void;
  party?: Maybe<IDepositor | IBeneficiary>;
}>();

const PartyContextProvider = ({
  escrowId,
  children,
  type,
  party,
  agreementForm,
  basePath,
}: {
  escrowId: string;
  children: React.ReactNode;
  type: EscrowPartyTypeEnum;
  party?: Maybe<IDepositor | IBeneficiary>;
  agreementForm: AgreementFormEnum;
  basePath: string;
}) => {
  const navigate = useNavigate();

  const onEdit = useCallback(
    () =>
      navigate({
        pathname: `${basePath}/onboarding/${escrowId}/${type}`,
        search: createSearchParams({
          isEdit: 'true',
        }).toString(),
      }),
    [],
  );

  const showSignatories =
    agreementForm === AgreementFormEnum.Tripartite ||
    (agreementForm === AgreementFormEnum.Bipartite && type === EscrowPartyTypeEnum.Depositor);

  return <PartyProvider value={{ type, agreementForm, party, showSignatories, onEdit }}>{children}</PartyProvider>;
};

export { useParty, PartyContextProvider };
